import { useQueryClient } from '@tanstack/react-query';

import { deleteNotification } from '../../api/notifications.api';
import useMutation from '../base/useMutation';
import { queryKeys } from '../../queryKeys';

export function useDeleteNotification() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => deleteNotification(id),
    onSuccess: () => {
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.notifications.unreadCount().queryKey,
      });
      queryClient.invalidateQueries({
        exact: false,
        queryKey: queryKeys.notifications.fetchInfiniteNotifications._def,
      });
    },
  });
}
